import { render, staticRenderFns } from "./custbillTotalstyle.vue?vue&type=template&id=61e72bf1&scoped=true&"
import script from "./custbillTotalstyle.vue?vue&type=script&lang=js&"
export * from "./custbillTotalstyle.vue?vue&type=script&lang=js&"
import style0 from "./custbillTotalstyle.vue?vue&type=style&index=0&id=61e72bf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e72bf1",
  null
  
)

export default component.exports